import React from 'react'
import { NavDropdown } from 'react-bootstrap'
import { matchPath, NavLink, useLocation } from 'react-router-dom'
import some from 'lodash/some'
import { Icon } from '@ztechapps/webui.util'

export type SubMenuItemProps = {
  icon: string
  name: string
  subMenu: {
    name: string
    url: string
    icon: string
    /** Routes outside `url` that belong to this entry — its detail page or another view of its list. */
    otherPaths?: string[]
  }[]
}
export const SubMenuItem = ({ icon, name, subMenu }: SubMenuItemProps) => {
  const { pathname } = useLocation()
  // NavDropdown has no active state of its own: active on any page of an entry — its url and
  // everything under it, plus its otherPaths.
  const active = some(subMenu, ({ url, otherPaths = [] }) =>
    some([url, ...otherPaths], (path) => !!matchPath({ path, end: false }, pathname))
  )
  return (
    <NavDropdown
      active={active}
      title={
        <>
          <Icon name={icon} /> {name}
        </>
      }
    >
      {subMenu.map(({ name, url, icon }) => (
        <NavDropdown.Item as={NavLink} to={url} key={name}>
          <Icon name={icon} /> {name}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  )
}
